module.exports = __webpack_public_path__ + "static/img/topic-banner.402b729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topic-banner.png
// module id = PZfV
// module chunks = 52